<template>
	<BackButton :text="t('back_button.overview')" link="PuzzleOverview" />
	<!-- <InfoButton v-if="PuzzleActive" @click="showOverlay" /> -->
	<PuzzleOverlay v-if="overlayVisible" @click="hideOverlay" />
	<div id="puzzle" class="animate__animated">
		<div class="container-fluid px-0 h-100 w-100">
			<canvas id="canvas"></canvas>
		</div>
		<div id="puzzle-start" class="d-none animate__animated" @click="shufflePuzzle">
			<div class="d-flex h-100">
				<div class="m-auto">
					<div class="puzzle-btn animate__animated" id="start-btn">
						<div class="d-flex h-100">
							<h1 class="my-auto mx-auto">{{ t('puzzle_text.start') }}</h1>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="puzzle-end" class="d-none animate__animated" @click="restartPuzzle">
			<div class="d-flex h-100">
				<div class="m-auto">
					<div class="puzzle-btn animate__animated" id="restart-btn">
						<div class="d-flex h-100">
							<h1 class="my-auto mx-auto">{{ t('puzzle_text.retry') }}</h1>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="puzzle-options" class="d-nones animate__animated">
			<div class="d-flex h-100">
				<div class="m-auto">
					<div class="puzzle-btn animate__animated animate__bounceInDown" id="difficulty-easy" @click="setDifficulty(3)">
						<div class="d-flex h-100">
							<h1 class="my-auto mx-auto">{{ t('puzzle_text.easy') }}</h1>
						</div>
					</div>
					<div class="puzzle-btn animate__animated animate__bounceInLeft" id="difficulty-normal" @click="setDifficulty(4)">
						<div class="d-flex h-100">
							<h1 class="my-auto mx-auto">{{ t('puzzle_text.normal') }}</h1>
						</div>
					</div>
					<div class="puzzle-btn animate__animated animate__bounceInUp" id="difficulty-hard" @click="setDifficulty(5)">
						<div class="d-flex h-100">
							<h1 class="my-auto mx-auto">{{ t('puzzle_text.hard') }}</h1>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import BackButton from "@/components/buttons/BackButton.vue";
import PuzzleOverlay from "@/components/puzzle/Overlay.vue";
import InfoButton from "@/components/buttons/InfoButton.vue";
import OverlayButton from "@/components/overlay/OverlayButton.vue";
import Confetti from "canvas-confetti";

export default {
	name: "Timeline",
	components: {
		BackButton,
		OverlayButton,
		PuzzleOverlay,
		InfoButton,
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
	data() {
		return {
			Canvas: null,
			Context: null,
			PuzzleImage: null,
			PuzzlePieces: [],
			PuzzleWidth: null,
			PuzzleHeight: null,
			CanvasWidth: 1920,
			CanvasHeight: 990,
			PieceWidth: null,
			PieceHeight: null,
			CurrentPiece: null,
			CurrentDropPiece: null,
			Pointer: null,
			Difficulty: 3,
			DifficultyOverlay: null,
			StartOverlay: null,
			EndOverlay: null,
			ConfettiAllowed: true,
			EasyBtn: null,
			NormalBtn: null,
			HardBtn: null,
			StartBtn: null,
			RestartBtn: null,
			PuzzleActive: false,
		};
	},
	beforeRouteLeave(to, from, next) {
		next();

		this.ConfettiAllowed = false;
		this.showLogo();
	},
	mounted() {
		const { t, te, tm } = useI18n();

		// All the buttons
		this.EasyBtn = document.getElementById("difficulty-easy");

		this.NormalBtn = document.getElementById("difficulty-normal");

		this.HardBtn = document.getElementById("difficulty-hard");

		this.StartBtn = document.getElementById("start-btn");

		this.RestartBtn = document.getElementById("restart-btn");

		// The canvas where the puzzle image will we shown
		this.Canvas = document.getElementById("canvas");
		this.Context = this.Canvas.getContext("2d");

		// Hide Logo
		this.hideLogo();

		// Difficulty Overlay
		this.DifficultyOverlay = document.getElementById("puzzle-options");

		// Start Overlay
		this.StartOverlay = document.getElementById("puzzle-start");

		// End Overlay
		this.EndOverlay = document.getElementById("puzzle-end");

		// The puzzle image we show
		this.PuzzleImage = new Image();
		this.PuzzleImage.addEventListener("load", this.onImageLoaded, false);
		// this.PuzzleImage.src = t("puzzle.image");
		this.PuzzleImage.src = t(`puzzle[${this.$route.params.id}].image`);

		// All the pieces of the puzzle
		this.PuzzlePieces = [];
		this.Pointer = { x: 0, y: 0 };
		this.CurrentPiece = null;
		this.CurrentDropPiece = null;
	},
	methods: {
		fireWorks() {
			let duration = 15 * 1000;
			let animationEnd = Date.now() + duration;
			let defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

			let interval = setInterval(() => {
				let timeLeft = animationEnd - Date.now();

				if (timeLeft <= 0 || !this.ConfettiAllowed) {
					return clearInterval(interval);
				}

				let particleCount = 50 * (timeLeft / duration);
				// since particles fall down, start a bit higher than random
				Confetti(Object.assign({}, defaults, { particleCount, origin: { x: Math.random() * (0.3 - 0.1) + 0.1, y: Math.random() - 0.2 } }));
				Confetti(Object.assign({}, defaults, { particleCount, origin: { x: Math.random() * (0.9 - 0.7) + 0.7, y: Math.random() - 0.2 } }));
			}, 250);
		},
		setDifficulty(difficulty) {
			this.Difficulty = difficulty;

			this.PieceWidth = Math.floor(this.CanvasWidth / this.Difficulty);
			this.PieceHeight = Math.floor(this.CanvasHeight / this.Difficulty);

			this.PuzzleWidth = this.PieceWidth * this.Difficulty;
			this.PuzzleHeight = this.PieceHeight * this.Difficulty;

			let xPos = 0;
			let yPos = 0;

			this.PuzzlePieces = [];

			for (let i = 0; i < this.Difficulty * this.Difficulty; i++) {
				let piece = { sx: xPos, sy: yPos };
				this.PuzzlePieces.push(piece);

				xPos += this.PieceWidth;

				if (xPos >= this.PuzzleWidth) {
					xPos = 0;
					yPos += this.PieceHeight;
				}
			}

			this.EasyBtn.classList.add("animate__bounceOutUp");
			this.NormalBtn.classList.add("animate__bounceOutLeft");
			this.HardBtn.classList.add("animate__bounceOutDown");

			this.DifficultyOverlay.classList.add("animate__fadeOut");

			setTimeout(() => {
				this.Canvas.addEventListener("touchstart", this.shufflePuzzle);

				this.Canvas.addEventListener("mousedown", this.shufflePuzzle);

				this.DifficultyOverlay.classList.add("d-none");
				this.StartOverlay.classList.remove("d-none");

				this.StartBtn.classList.add("animate__bounceIn");
			}, 800);
		},
		onImageLoaded(event) {
			this.Canvas.width = this.CanvasWidth;
			this.Canvas.height = this.CanvasHeight;

			this.Context.drawImage(this.PuzzleImage, 0, 0, this.CanvasWidth, this.CanvasHeight, 0, 0, this.CanvasWidth, this.CanvasHeight);
		},
		restartPuzzle() {
			// Remove the bounce out classes
			this.EasyBtn.classList.remove("animate__bounceOutUp");
			this.NormalBtn.classList.remove("animate__bounceOutLeft");
			this.HardBtn.classList.remove("animate__bounceOutDown");

			// Remove the fadeout
			this.DifficultyOverlay.classList.remove("animate__fadeOut");

			this.EndOverlay.classList.remove("animate__bounceIn");
			this.EndOverlay.classList.add("animate__bounceOut");

			setTimeout(() => {
				this.Canvas.addEventListener("touchstart", this.shufflePuzzle);

				this.Canvas.addEventListener("mousedown", this.shufflePuzzle);

				this.EndOverlay.classList.remove("animate__bounceOut");
				this.EndOverlay.classList.add("d-none");
			}, 800);

			this.DifficultyOverlay.classList.remove("d-none");
			this.DifficultyOverlay.classList.add("animate__fadeIn");

			this.ConfettiAllowed = false;

			this.PuzzleActive = false;
		},
		createTitle(msg) {
			this.Context.fillStyle = "#000000";
			this.Context.globalAlpha = 0.4;
			this.Context.fillRect(100, this.PuzzleHeight / 2 - 50, this.PuzzleWidth - 200, 100);
			this.Context.fillStyle = "#FFFFFF";
			this.Context.globalAlpha = 1;
			this.Context.textAlign = "center";
			this.Context.textBaseline = "middle";
			this.Context.font = "50px Arial";
			this.Context.fillText(msg, this.PuzzleWidth / 2, this.PuzzleHeight / 2);
		},
		buildPieces() {
			let xPos = 0;
			let yPos = 0;

			for (let i = 0; i < this.Difficulty * this.Difficulty; i++) {
				let piece = { sx: xPos, sy: yPos };
				this.PuzzlePieces.push(piece);

				xPos += this.PieceWidth;

				if (xPos >= this.PuzzleWidth) {
					xPos = 0;
					yPos += this.PieceHeight;
				}
			}
		},
		shufflePuzzle() {
			this.StartBtn.classList.add("animate__bounceOut");
			this.StartOverlay.classList.add("animate__fadeOut");

			this.Canvas.removeEventListener("touchstart", this.shufflePuzzle);

			this.Canvas.removeEventListener("mousedown", this.shufflePuzzle);

			setTimeout(() => {
				this.StartOverlay.classList.add("d-none");
				this.StartOverlay.classList.remove("animate__fadeOut");
				this.StartBtn.classList.remove("animate__bounceOut");

				this.PuzzlePieces = this.shuffleArray(this.PuzzlePieces);
				this.Context.clearRect(0, 0, this.PuzzleWidth, this.PuzzleHeight);

				let xPos = 0;
				let yPos = 0;

				for (let i = 0; i < this.PuzzlePieces.length; i++) {
					let piece = this.PuzzlePieces[i];
					piece.xPos = xPos;
					piece.yPos = yPos;

					this.Context.drawImage(this.PuzzleImage, piece.sx, piece.sy, this.PieceWidth, this.PieceHeight, xPos, yPos, this.PieceWidth, this.PieceHeight);
					this.Context.strokeRect(xPos, yPos, this.PieceWidth, this.PieceHeight);

					xPos += this.PieceWidth;

					if (xPos >= this.PuzzleWidth) {
						xPos = 0;
						yPos += this.PieceHeight;
					}
				}

				this.Canvas.addEventListener("touchstart", this.onPuzzleClick);

				this.Canvas.addEventListener("mousedown", this.onPuzzleClick);

				this.PuzzleActive = true;
			}, 800);
		},
		onPuzzleClick(e) {
			let location = this.getMouseOrTouchLocation(e);

			this.Pointer.x = location.x - this.Canvas.offsetLeft;
			this.Pointer.y = location.y - this.Canvas.offsetTop;

			this.CurrentPiece = this.checkPieceClicked();

			if (this.CurrentPiece != null) {
				this.Context.clearRect(this.CurrentPiece.xPos, this.CurrentPiece.yPos, this.PieceWidth, this.PieceHeight);
				this.Context.save();
				this.Context.globalAlpha = 0.9;
				this.Context.drawImage(this.PuzzleImage, this.CurrentPiece.sx, this.CurrentPiece.sy, this.PieceWidth, this.PieceHeight, this.Pointer.x - this.PieceWidth / 2, this.Pointer.y - this.PieceHeight / 2, this.PieceWidth, this.PieceHeight);
				this.Context.restore();

				this.Canvas.addEventListener("touchmove", this.updatePuzzle);
				this.Canvas.addEventListener("touchend", this.pieceDropped);

				this.Canvas.addEventListener("mousemove", this.updatePuzzle);
				this.Canvas.addEventListener("mouseup", this.pieceDropped);
			}
		},
		checkPieceClicked() {
			for (let i = 0; i < this.PuzzlePieces.length; i++) {
				let piece = this.PuzzlePieces[i];

				if (this.Pointer.x > piece.xPos && this.Pointer.x < piece.xPos + this.PieceWidth && this.Pointer.y > piece.yPos && this.Pointer.y < piece.yPos + this.PieceHeight) {
					return piece;
				}
			}

			return null;
		},
		updatePuzzle(e) {
			// fixes laggy touch movement
			e.preventDefault();

			this.CurrentDropPiece = null;

			let location = this.getMouseOrTouchLocation(e);

			this.Pointer.x = location.x - this.Canvas.offsetLeft;
			this.Pointer.y = location.y - this.Canvas.offsetTop;

			this.Context.clearRect(0, 0, this.PuzzleWidth, this.PuzzleHeight);

			for (let i = 0; i < this.PuzzlePieces.length; i++) {
				let piece = this.PuzzlePieces[i];

				if (piece == this.CurrentPiece) {
					continue;
				}

				this.Context.drawImage(this.PuzzleImage, piece.sx, piece.sy, this.PieceWidth, this.PieceHeight, piece.xPos, piece.yPos, this.PieceWidth, this.PieceHeight);
				this.Context.strokeRect(piece.xPos, piece.yPos, this.PieceWidth, this.PieceHeight);

				if (this.CurrentDropPiece == null) {
					if (this.Pointer.x > piece.xPos && this.Pointer.x < piece.xPos + this.PieceWidth && this.Pointer.y > piece.yPos && this.Pointer.y < piece.yPos + this.PieceHeight) {
						this.CurrentDropPiece = piece;
						this.Context.save();
						this.Context.globalAlpha = 0.4;
						this.Context.fillStyle = "#009900";
						this.Context.fillRect(this.CurrentDropPiece.xPos, this.CurrentDropPiece.yPos, this.PieceWidth, this.PieceHeight);
						this.Context.restore();
					}
				}
			}

			this.Context.save();
			this.Context.globalAlpha = 0.6;
			this.Context.drawImage(this.PuzzleImage, this.CurrentPiece.sx, this.CurrentPiece.sy, this.PieceWidth, this.PieceHeight, this.Pointer.x - this.PieceWidth / 2, this.Pointer.y - this.PieceHeight / 2, this.PieceWidth, this.PieceHeight);
			this.Context.restore();
			this.Context.strokeRect(this.Pointer.x - this.PieceWidth / 2, this.Pointer.y - this.PieceHeight / 2, this.PieceWidth, this.PieceHeight);
		},
		pieceDropped(e) {
			this.Canvas.removeEventListener("touchmove", this.updatePuzzle);
			this.Canvas.removeEventListener("touchend", this.pieceDropped);

			this.Canvas.removeEventListener("mousemove", this.updatePuzzle);
			this.Canvas.removeEventListener("mouseup", this.pieceDropped);

			if (this.CurrentDropPiece != null) {
				var tmp = { xPos: this.CurrentPiece.xPos, yPos: this.CurrentPiece.yPos };
				this.CurrentPiece.xPos = this.CurrentDropPiece.xPos;
				this.CurrentPiece.yPos = this.CurrentDropPiece.yPos;
				this.CurrentDropPiece.xPos = tmp.xPos;
				this.CurrentDropPiece.yPos = tmp.yPos;
			}

			this.resetPuzzleAndCheckWin();
		},
		showEndOverlay() {
			this.EndOverlay.classList.add("animate__bounceIn");
			this.EndOverlay.classList.remove("d-none");
		},
		resetPuzzleAndCheckWin() {
			this.Context.clearRect(0, 0, this.PuzzleWidth, this.PuzzleHeight);

			let win = true;

			for (let i = 0; i < this.PuzzlePieces.length; i++) {
				let piece = this.PuzzlePieces[i];

				this.Context.drawImage(this.PuzzleImage, piece.sx, piece.sy, this.PieceWidth, this.PieceHeight, piece.xPos, piece.yPos, this.PieceWidth, this.PieceHeight);
				this.Context.strokeRect(piece.xPos, piece.yPos, this.PieceWidth, this.PieceHeight);

				if (piece.xPos != piece.sx || piece.yPos != piece.sy) {
					win = false;
				}
			}

			if (win) {
				this.Context.drawImage(this.PuzzleImage, 0, 0, this.CanvasWidth, this.CanvasHeight, 0, 0, this.CanvasWidth, this.CanvasHeight);

				this.ConfettiAllowed = true;

				this.fireWorks();

				setTimeout(this.showEndOverlay, 2000);

				this.Canvas.removeEventListener("touchstart", this.onPuzzleClick);
				this.Canvas.removeEventListener("touchmove", this.updatePuzzle);
				this.Canvas.removeEventListener("touchend", this.pieceDropped);

				this.Canvas.removeEventListener("mousedown", this.onPuzzleClick);
				this.Canvas.removeEventListener("mousemove", this.updatePuzzle);
				this.Canvas.removeEventListener("mouseup", this.pieceDropped);
			}
		},
		shuffleArray(o) {
			for (var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
			return o;
		},
		getMouseOrTouchLocation(e) {
			if (e.type == "touchstart" || e.type == "touchmove" || e.type == "touchend" || e.type == "touchcancel") {
				var touch = e.touches[0] || e.changedTouches[0];
				return { x: touch.pageX, y: touch.pageY };
			} else if (e.type == "mousedown" || e.type == "mouseup" || e.type == "mousemove" || e.type == "mouseover" || e.type == "mouseout" || e.type == "mouseenter" || e.type == "mouseleave") {
				return { x: e.clientX, y: e.clientY };
			}
		},
	},
};
</script>

<style scoped>
#puzzle-options {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: rgba(31, 31, 31, 0.85);
	z-index: 1;
}

#puzzle-start {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 1;
}

#puzzle-end {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 1;
}

.puzzle-btn {
	height: 164px;
	padding: 10px 50px;
	margin: auto;
	background: white;
}

.puzzle-btn h1 {
	font-size: 100px;
}

.puzzle-btn:not(:last-child) {
	margin-bottom: 40px;
}
</style>